import { Box, Button, Fade, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { getAcolitos } from "../../helpers/acolitos";
import { Add } from "@mui/icons-material";

export const Acolitos = () => {
  //Nombre de la pestaña
  document.title = "Acólitos";
  const [loading, setLoading] = useState(true);

  const [rows, setRows] = useState([]);

  const columns = [
    {
      field: "nombre_completo",
      headerName: "Nombre completo",
      width: 300,
      renderCell: (params) => {
        return (
          <Typography
            sx={{
              color: "primary.dark",
              display: "flex",
              alignItems: "center",
              height: "100%",
              fontWeight: 600,
            }}
          >
            {params.row.nombre_completo}
          </Typography>
        );
      },
    },
    {
      field: "cargo",
      headerName: "Cargo",
      width: 200,
    },
    {
      field: "equipo",
      headerName: "Equipo",
      width: 200,
    },
    {
      field: "celular",
      headerName: "Celular",
      width: 110,
    },
    {
      field: "correo",
      headerName: "Correo",
      width: 200,
    },
    {
      field: "medalla",
      headerName: "Medalla",
      width: 70,
    },
    {
      field: "fecha_nacimiento",
      headerName: "Fecha de nacimiento",
      width: 150,
    },
    {
      field: "estatura",
      headerName: "Estatura (m)",
      width: 100,
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 150,
      renderCell: (params) => {
        //Mostrar activo o inactivo y cambiar el color del texto
        return (
          <Typography
            style={{
              color: params.row.estatus === "Activo" ? "green" : "red",
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            {params.row.estatus}
          </Typography>
        );
      },
    },
  ];

  useEffect(() => {
    if (!loading) return;

    getAcolitos().then((acolitos) => {
      setRows(acolitos);
      setLoading(false);
    });
  }, [loading]);

  return (
    <Fade in={true} timeout={1000}>
      <div>
        <Box sx={{ display: "flex", paddingLeft: 5 }}>
          <Button variant="contained" color="primary" href="/acolitos/nuevo">
            <Add />
            Nuevo acólito
          </Button>
          <Box sx={{ marginRight: 5 }}>
            <Typography
              id="transition-modal-title"
              variant="h4"
              color="primary"
              fontWeight={900}
              position={"absolute"}
              right={50}
            >
              ACÓLITOS
            </Typography>
          </Box>
        </Box>
        <div style={{ width: "100%", padding: 20, marginTop: 15 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            slots={{
              toolbar: GridToolbar,
            }}
            loading={loading}
            onRowClick={(row) => {
              window.location.href = `/acolitos/${row.row.id}`;
            }}
          />
        </div>
      </div>
    </Fade>
  );
};
